import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  id: PropTypes.string,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.string,
  className: PropTypes.string,
  step: PropTypes.string,
  onBlur: PropTypes.func,
};

const defaultProps = {
  id: '',
  required: false,
  onChange: null,
  type: 'text',
  value: '',
  className: '',
  step: '',
};

const TextInput = props => {
  const {
    name,
    id,
    type,
    placeholder,
    onChange,
    required,
    value,
    className,
    step,
    innerRef,
    onBlur,
    ...rest
  } = props;

  return (
    <input
      {...rest}
      ref={innerRef}
      className={clsx(className, 'appearance-none block w-full')}
      step={step}
      name={name}
      id={id}
      type={type}
      placeholder={placeholder}
      onChange={e => {
        if (onChange) {
          return onChange(e);
        } else {
          return null;
        }
      }}
      required={required}
      value={value}
      onBlur={onBlur}
    />
  );
};

TextInput.propTypes = propTypes;
TextInput.defaultProps = defaultProps;

export default TextInput;
